import Model, { attr, belongsTo } from '@ember-data/model';
import { computed } from '@ember/object';
import { not } from '@ember/object/computed';

export default class VfUserModel extends Model {
  @attr('string') coduser;

  @attr('string') nombre;

  @attr('string') email;

  @attr('boolean') esInactivo;

  @belongsTo('vf-perfil', { async: false, inverse: null }) perfil;

  @not('esInactivo') activo;

  @computed('activo')
  get activoFormatted() {
    return this.activo ? 'Sí' : 'No';
  }
}
